type Props = {
  isSent: boolean;
  isIframe: boolean | undefined;
  botAvatar: string;
  isLastMessage: boolean | undefined;
};

function MessageAvatar(props: Props) {
  const { isSent, isIframe, botAvatar, isLastMessage } = props;

  if (isSent) {
    return;
  }

  if (isIframe) {
    if (isLastMessage) {
      return <img className="wobble h-8 w-8" src={botAvatar} />;
    }
    return <img className="h-8 w-8" src={botAvatar} />;
  }
  return <img className="h-7 w-7 min-w-[28px]" src={botAvatar} />;
}

export default MessageAvatar;
